import request from '@/utils/request'
// 秒杀列表
export function flashList(params) {
  return request({
    url: '/sec/kill',
    method: 'get',
    params
  })
}
// 添加秒杀
export function createFlash(data) {
  return request({
    url: '/sec/kill',
    method: 'post',
    data
  })
}
// 修改秒杀
export function updateFlash(data) {
  return request({
    url: '/sec/kill',
    method: 'put',
    data
  })
}
// 秒杀详情
export function flashDetail(id) {
  return request({
    url: '/sec/kill/' + id,
    method: 'get'
  })
}
// 删除秒杀
export function deleteFlash(id) {
  return request({
    url: '/sec/kill/' + id,
    method: 'delete'
  })
}
// 秒杀时间列表
export function flashTimeList() {
  return request({
    url: '/sec/kill/time',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/flash.js